export const generateDisplaySeatArray = (seats) => {
  const res = [];
  for (var i = 0; i < seats.length; i++) {
    const seat = seats[i];

    const targetIndex = res.findIndex(e => e.car_number == seat.car_number)
    if (targetIndex >= 0) {
      res[targetIndex].display_number_array.push(seat.display_number)
    } else {
      res.push({
        "car_number": seat.car_number,
        "display_number_array": [seat.display_number]
      });
    }
  }
  return res;
}